import React from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';

function Title(
    {
        children,
        align,
        className,
        variant='h5'
    }) {
    return (
        <Typography
            variant={variant}
            align={align}
            className={className}
        >
            {children}
        </Typography>
    )
}

Title.propTypes = {
    align: PropTypes.string,
    className: PropTypes.string,
}

Title.defaultProps = {}

export default Title;